// library imports
import { useDispatch } from "react-redux";

// User Component imports
import { ExecOpsRequest } from "apis/AdminOpsApiCommon";

// 運営ツール: プロンプトのバージョンにスターを付け外し
const AdminOpsPromptStarApi = () => {
    const dispatch = useDispatch();
    const url = "/admin/ops_prompt_star";

    const ExecAdminOpsPromptStarApi = async (groupKey, v, isStarred) => {
        return ExecOpsRequest(dispatch, { url: url, requestParams: { group_key: groupKey, v: v, is_starred: isStarred ? 1 : 0 } });
    };

    return ExecAdminOpsPromptStarApi;
};

export default AdminOpsPromptStarApi;
